import { createEnv } from "@t3-oss/env-core";
import * as z from "zod";

export const env = createEnv({
  clientPrefix: "ADMIN__",
  client: {
    ADMIN__API_URL: z.url().default("http://localhost:3000"),
    ADMIN__AUTH_URL: z.url().default("http://localhost:3002"),
    ADMIN__APP_URL: z.url().default("http://localhost:3001"),
  },
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
});
